import { FC } from 'react';
import cx from 'clsx';
import { SlotInfo, Views } from 'react-big-calendar';
import styles from './styles.module.css';

type Props = {
  children: React.ReactNode;
  value: Date;
  isInCampaignRange: boolean;
  currentView: (typeof Views)[keyof typeof Views];
  onAddEvent: (slotInfo: SlotInfo) => void;
};

export const MonthCellWrapper: FC<Props> = ({
  children,
  value,
  isInCampaignRange,
  currentView,
  onAddEvent,
}) => {
  const handleCellAddEvent = () => {
    if (!isInCampaignRange) {
      return;
    }

    const slotInfo: SlotInfo = {
      start: value,
      end: value,
      slots: [value],
      action: 'select',
    };
    onAddEvent(slotInfo);
  };

  return (
    <button
      onClick={handleCellAddEvent}
      className={cx({
        [styles.monthCell]: true,
        [styles.disabledMonthCell]: !isInCampaignRange,
      })}
    >
      {children}
      {isInCampaignRange && currentView === Views.MONTH && (
        <span className={styles.addEventButton} title="Add event">
          + Add new
        </span>
      )}
    </button>
  );
};
